import React from 'react'

function SupportOnline() {
  return (
    <div style={{margin : "5px"}}>
      <h3>پشتیبانی فروشگاه اینترنتی:</h3>
      <h4>مشاور خرید از سایت </h4>
      {/* <h4>09155509323</h4> */}
      <a href={`tel:09155509323`}>09155509323</a>
      <h4>پشتیبانی وبسایت</h4>
      {/* <h4>09360757507</h4> */}
      <a href={`tel:09360757507`}>09360757507</a>
      {/* <h4>05138780101</h4> */}
      <br />
      <a href={`tel:05138780101`}>05138780101</a>

    </div>
  )
}

export default SupportOnline